import { useLayoutEffect } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { Footer } from '../components/Dashboard/Footer'
import { Header } from '../components/Dashboard/Header'
import { selectCurrentToken } from '../features/auth/authSlice'
import { useBodyScrollable } from '../hooks/useBodyScrollable'
import { getScrollbarWidth } from '../utils/getScrollbarWidth'
import { LevelUpProvider } from '../contexts/LevelUpContext'
import { LeaderboardRewardProvider } from '../contexts/LeaderboardRewardContext'

export const DashboardLayout = () => {
  const scrollbarWidth = getScrollbarWidth()
  const bodyScrollable = useBodyScrollable()
  useLayoutEffect(() => {
    if (bodyScrollable) {
      document.body.style.paddingRight = '0px'
    } else {
      document.body.style.paddingRight = `${scrollbarWidth}px`
    }
  }, [bodyScrollable])

  const token = useSelector(selectCurrentToken)
  const location = useLocation()

  return token ? (
    <LevelUpProvider>
      <LeaderboardRewardProvider>
      <div className='bg-background font-dashboard min-h-screen relative'>
        <Header />
        <div>
          <Outlet />
        </div>
        <Footer />
      </div>
      </LeaderboardRewardProvider>
    </LevelUpProvider>
  ) : (
    <Navigate to='/' state={{ from: location }} replace />
  )
}
